module.exports = __webpack_public_path__ + "static/MapCC_2024-db70bbbe8154df3dab5ca1d7b0adce61.png";